import styled from 'styled-components';
import { baseVariables } from '../../styles/index';

export const OverlayWrapper = styled.div`
  &&& {
    padding: 0 !important;
  }
  display: inline-block;
  position: relative;
  background-color: ${baseVariables.color.base10};
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  color: ${baseVariables.color.base20};
  cursor: pointer;
  box-shadow: 0 0.5rem 0.875rem 0 rgba(0, 0, 0, 0.25);
  font-size: 0.8125rem;
  line-height: 0.8125rem;
  transform: translate(-50%, -100%);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -0.3125rem;
    border-width: 0.3125rem;
    border-style: solid;
    border-color: ${baseVariables.color.base10} transparent transparent transparent;
  }
`;
